/**
 * 「고르기」 칸의 **값 모양** — 화면 쪽 (2026-09-04 · 예산 판 B0).
 *
 * ★★★ 서버의 `apps/chat-server/src/modules/approval/form-select.ts` 와 **같은 규약**이다.
 *      값은 **`{ code, label }`** — 코드는 붙이는 데(예산·근태) 쓰고, 이름은 **그때 본 그대로** 남는다.
 *      이름만 담으면 회사가 이름을 고쳤을 때 옛 문서가 무엇을 고른 것인지 알 수 없고,
 *      코드만 담으면 문서를 여는 곳마다 목록 조회가 붙는 데다 **옛 문서의 표시가 뒤늦게 바뀐다**
 *      (「넘어간 문서는 안 바뀐다」와 어긋난다).
 *
 * ★★ **옛 값은 이름 문자열이다 — 막지 않는다.** 이미 저장된 문서가 그렇다.
 *     읽는 쪽은 이 두 함수 하나로 둘을 같게 다룬다.
 *
 * ⚠ 서버 파일과 **글자까지 같게 두지는 않는다**(계산식 `COLUMN_KINDS` 처럼 동기 검사가 걸린 짝이 아니다).
 *   대신 **함수 이름과 판정이 같아야** 한다 — 한쪽만 고치면 화면과 저장이 갈린다.
 */

/** 고르기 값 — 새 값은 `{code,label}`, 옛 값은 이름 문자열. */
export type SelectValue = string | { code: string; label: string };

/** 고를 수 있는 한 항목 — 목록 주인이 주는 모양. */
export interface SelectOption { code: string; label: string }

/** 그 값이 새 모양인가. */
export function isSelectPair(v: unknown): v is { code: string; label: string } {
  if (typeof v !== 'object' || v === null) return false;
  const o = v as { code?: unknown; label?: unknown };
  return typeof o.code === 'string' && o.code !== '' && typeof o.label === 'string';
}

/** 화면에 보일 이름 — 새 값은 **그때 담긴 이름**을 그대로 준다. */
export function selectLabel(v: unknown): string {
  if (isSelectPair(v)) return v.label;
  return typeof v === 'string' ? v : '';
}

/** 붙이는 데 쓸 코드 — 옛 값(이름)은 이름을 그대로 준다(되짚기가 둘 다 받는다). */
export function selectCode(v: unknown): string {
  if (isSelectPair(v)) return v.code;
  return typeof v === 'string' ? v : '';
}
